<table class="table table-centered table-nowrap">    
    <thead>
        <th>{{'Common.ItemCode'|translate}}</th>
        <th>{{'Common.ItemName'|translate}}</th>
        <th>{{'Common.Amount'|translate}}</th>
        <th>{{'Common.UnitPrice'|translate}}</th>
        <th>{{'Common.VatAmount'|translate}}</th>
        <th>{{'Common.VatPrice'|translate}}</th>                        
    </thead>
    <tbody>
        <tr *ngFor="let bill of dataSource">
            <td>{{ bill.I_CODE }}</td>
            <td>{{ bill.Note }}</td>
            <td>{{ bill.I_QTY }}</td>
            <td>{{ bill.I_PRICE }}</td>
            <td>{{ bill.VAT_PER }}</td>
            <td>{{ bill.VAT_AMT }}</td>
        </tr>
    </tbody>
</table>